export const makePickSavingField =
  (isSelectedAllFacility: boolean) =>
  <T extends string | number>(customerCurrency: T, facilityCurrency: T) =>
    isSelectedAllFacility ? customerCurrency : facilityCurrency;
